module.exports = __webpack_public_path__ + "media/images/gift-box-svgrepo-com-37f78037788ed327ee22752976a0fe5b.svg";